export default __webpack_public_path__ + "static/assets/f381c9e58b1ba5a196274727f6580a20.png";